<template>
  <SoPageWithHeader title="Warrants">
    <div class="d-flex align-center justify-space-between mb-4">
      <SoButton
        type="text"
        title="Back to services"
        prepend-icon="arrow-left"
        class="px-0"
        data-testid="warrants-back-btn"
        :to="{ name: RouteNames.AdminServices }"
      />
      <div class="d-flex ga-2">
        <SoButton
          type="primary"
          title="DCA Queue"
          prepend-icon="list"
          data-testid="warrants-dca-btn"
          :to="{
            name: RouteNames.AdminServiceWarrantsDca,
            params: { serviceName: $route.params.serviceName },
          }"
        />
        <SoButton
          type="primary"
          title="DCA Files"
          prepend-icon="list"
          data-testid="warrants-files-btn"
          :to="{
            name: RouteNames.AdminServiceWarrantsFiles,
            params: { serviceName: $route.params.serviceName },
          }"
        />
      </div>
    </div>

    <WarrantsSummaryCard class="mb-4" />

    <SoTabs v-model="currentTab" divider data-testid="warrants-tabs">
      <SoTab title="Jobs">
        <div class="pt-4">
          <WarrantsJobsTab />
        </div>
      </SoTab>
      <SoTab title="Accounts">
        <div class="pt-4">
          <WarrantsAccountsTab />
        </div>
      </SoTab>
      <SoTab title="Whitelist">
        <div class="pt-4">
          <WarrantsWhitelistTab />
        </div>
      </SoTab>
    </SoTabs>
  </SoPageWithHeader>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoTabs from "@/components/tabs/SoTabs.vue"
  import SoTab from "@/components/tabs/SoTab.vue"
  import WarrantsJobsTab from "./components/WarrantsJobsTab.vue"
  import WarrantsAccountsTab from "./components/WarrantsAccountsTab.vue"
  import WarrantsWhitelistTab from "./components/WarrantsWhitelistTab.vue"
  import WarrantsSummaryCard from "./components/WarrantsSummaryCard.vue"
  import { RouteNames } from "@/types/router"

  // Tab indices match the order the SoTab children are declared.
  export enum WarrantsTab {
    Jobs = 0,
    Accounts = 1,
    Whitelist = 2,
  }

  // URL slug for each tab (index aligns with WarrantsTab) so the active tab is
  // reflected in the `?tab=` query — deep-linkable and restored on back nav.
  const TAB_SLUGS = ["jobs", "accounts", "whitelist"]

  export default defineComponent({
    components: {
      SoPageWithHeader,
      SoButton,
      SoTabs,
      SoTab,
      WarrantsJobsTab,
      WarrantsAccountsTab,
      WarrantsWhitelistTab,
      WarrantsSummaryCard,
    },
    data() {
      return {
        RouteNames,
      }
    },
    computed: {
      // The active tab is driven by the `?tab=` query param.
      currentTab: {
        get(): WarrantsTab {
          const index = TAB_SLUGS.indexOf(this.$route.query.tab as string)
          return index === -1 ? WarrantsTab.Jobs : index
        },
        set(tab: WarrantsTab) {
          // replace (not push) so switching tabs doesn't spam browser history.
          this.$router.replace({
            query: { ...this.$route.query, tab: TAB_SLUGS[tab] },
          })
        },
      },
    },
  })
</script>
